module.exports = __webpack_public_path__ + "img/toggles.bd956c56.svg";